
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { TextField } from 'office-ui-fabric-react/lib/TextField';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';

import useAuth from '../hooks/useAuth';
import useAuthToken from '../hooks/mysliveckyportal/useAuthToken';
import DialogAlert from './DialogAlert';
import { getActions as authGetActions } from '../sagas/auth';

const classNames = mergeStyleSets({
    ChangePasswordForm: {
        backgroundColor: '#ffffff',
        width: '400px',
        padding: '16px'
    },
});


const ChangePasswordForm = ({onCancelClick}) => {

    const dispatch = useDispatch();
    const authActions = authGetActions(dispatch);

    const auth = useAuth();
    const token = useAuthToken();

    const [passwordOld, setPasswordOld] = useState('');
    const [passwordNew, setPasswordNew] = useState('');
    const [passwordNew2, setPasswordNew2] = useState('');

    const checkParams = () => {
        let errors = [];
        if (!passwordOld) {
            errors.push('Aktuální heslo musí být zadané');
        }
        if (!(passwordNew && passwordNew2 && (passwordNew === passwordNew2))) {
            errors.push('Nové heslo a jeho potvrzení musí být zadané a musí se shodovat');
        }
        if ((passwordOld === passwordNew)) {
            errors.push('Aktuální heslo a nové heslo se nesmí shodovat');
        }

        return errors;
    }

    const handleCancelClick = () => {
        if (onCancelClick) {
            onCancelClick();
        }
    }

    const handleChangeClick = async (event) => {
        let errors = checkParams();
        if (errors.length === 0) {
            authActions.changePassword(token, passwordOld, passwordNew);
        } else {
            await DialogAlert.show(errors.reduce(
                (previous, current) => {
                    return previous + `- ${current}<br/>`;
                }, 'Nejsou splněny následující podmínky a proto nelze ve změně hesla pokračovat:<br/></br/>'),
                {minWidth: 500});
        }
    }

    const handleChangePasswordOld = (event) => {
        setPasswordOld(event.target.value);
    }

    const handleChangePasswordNew = (event) => {
        setPasswordNew(event.target.value);
    }

    const handleChangePasswordNew2 = (event) => {
        setPasswordNew2(event.target.value);
    }

    return (
        <Stack className={classNames.ChangePasswordForm} tokens={{childrenGap: 16}}>
            <Stack.Item>
                <TextField
                    label="Aktuální heslo"
                    type="password"
                    canRevealPassword={true}
                    disabled={auth.operationLoading}
                    onChange={handleChangePasswordOld}
                />
                <TextField
                    label="Nové heslo"
                    type="password"
                    canRevealPassword={true}
                    disabled={auth.operationLoading}
                    onChange={handleChangePasswordNew}
                />
                <TextField
                    label="Potvrzení nového hesla"
                    type="password"
                    canRevealPassword={true}
                    disabled={auth.operationLoading}
                    onChange={handleChangePasswordNew2}
                />
            </Stack.Item>
            <Stack.Item>
                <Stack horizontal tokens={{childrenGap: 8}}>
                    <PrimaryButton
                        text="Změnit heslo"
                        disabled={auth.operationLoading}
                        onClick={handleChangeClick}
                    />
                    <DefaultButton
                        text="Zpět"
                        onClick={handleCancelClick}
                    />
                </Stack>
            </Stack.Item>
        </Stack>
    );
}

export default ChangePasswordForm;
